import Selectr from 'mobius1-selectr'

up.compiler('[combo-box]', (element, { path, type }) => {
  const selectr = new Selectr(element, {
    searchable: false,
    allowDeselect: true,
    pagination: 30,
    customClass: element.getAttribute('modifier') || '',
    placeholder: element.getAttribute('placeholder') ,
    clearable: true,
    defaultSelected: false,
  })

  const label = element.closest('form').querySelector(`[for="${element.id}"]`)
  if ( label ) {
    label.addEventListener('click', () => {
      setTimeout(() => {
        selectr.open()
      })
    })
  }

  selectr.on('selectr.open', () => {
    setTimeout(() => {
      let selected = document.querySelector('.selectr-option.selected')
      if ( selected ) {
        selected.scrollIntoView({
          block: 'nearest',
        })
      }
    })
  })

  return () => {
    selectr.destroy()
  }
})
